<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { Question, QuestionAnswer } from "../../../models/question";
    import QuestionAnswerComponent from "./question-answer.component.svelte";

    const dispacth = createEventDispatcher();

    export let question: Question;

    const handleSelect = (answer: QuestionAnswer) => {
        question.answer = answer;
        dispacth("question-answer", question);
    };
</script>

<div>
    {question.label}
    <QuestionAnswerComponent
        on:click={() => handleSelect(QuestionAnswer.Yes)}
        selected={question.answer === QuestionAnswer.Yes}
    >
        Oui
    </QuestionAnswerComponent>
    <QuestionAnswerComponent
        on:click={() => handleSelect(QuestionAnswer.No)}
        selected={question.answer === QuestionAnswer.No}
    >
        Non
    </QuestionAnswerComponent>
    <QuestionAnswerComponent
        on:click={() => handleSelect(QuestionAnswer.DoNotKnow)}
        selected={question.answer === QuestionAnswer.DoNotKnow}
    >
        NSP
    </QuestionAnswerComponent>
</div>
